"use client";

import { Court } from "@/lib/courtData";
import { ExpertiseCityStringSet } from "@/lib/strings/expertiseCityStrings";
import { backgroundPaper } from "@/themeOptions";
import { SLCardWithImage } from "../cards/SLCardWithImage";
import { HowManyCards } from "../other/SLCarousel";
import { SLTruncatedText } from "../other/SLTruncatedText";
import { SLSectionCardsSlider } from "./SLSectionCardsSlider";

export function SLSectionCourtsSlider({
  expertiseCity,
  expertiseHubTitle,
}: {
  expertiseCity: ExpertiseCityStringSet;
  expertiseHubTitle: string;
}) {
  const defaultTitle = `${expertiseCity.city}: Zust\u00e4ndige Gerichte f\u00fcr das ${expertiseHubTitle}`;

  return (
    <SLSectionCardsSlider
      howManyCards={HowManyCards.OneToThree}
      hasPaddingTop={true}
      title={expertiseCity.courtsTitle ?? defaultTitle}
      subtitle={expertiseCity.courtsDescription}
      items={expertiseCity.courts}
      renderCard={(court: Court) => (
        <SLCardWithImage
          title={court.name}
          subtitle={court.sitz}
          description={
            <SLTruncatedText
              backgroundColor={backgroundPaper}
              text={court.description}
              maxLength={350}
            />
          }
          imageUrl={court.image}
          imageAlt={court.imageAlt}
          url={court.url}
        />
      )}
      getItemKey={(court: Court) => court.name}
      attributions={{
        items: expertiseCity.courts,
        getAttribution: (court: Court) =>
          court.imageLicence.author
            ? `${court.name}: Urheber ${court.imageLicence.author}, Lizenz ${court.imageLicence.licence}`
            : null,
        attributionLabel: "Bildnachweise",
      }}
    />
  );
}
